export const Checkbox = {
  baseStyle: {
    icon: {
      bg: 'primary-500',
      color: 'static-white',
    },
    control: {
      borderRadius: '4px',
      borderWidth: '2px',
      borderColor: 'ats-border-color',
      bg: 'white',
      _checked: {
        borderColor: 'primary-500',
        bg: 'primary-500',
      },
      _hover: {
        borderColor: 'light.border',
      },
      _active: {
        outline: 'none',
      },
      _focus: {
        boxShadow: 'none',
      },
    },
    label: {},
  },
  // Styles for the size variations
  sizes: {},
  // Styles for the visual style variations
  variants: {},
  // The default `size` or `variant` values
  defaultProps: {},
};
